import {
    TOPIC_LEADER_CONNECTION_STATUS,
    TOPIC_FORCE_RECONNECT,
    type ConnectionStatus,
} from 'lib/ws/constants'
import { getWsHub } from 'lib/ws/hub'
import { useCallback, useEffect, useState } from 'react'

type ConnectionStatusPayload = {
    status: ConnectionStatus
}

type WebsocketHealthResult = {
    status: ConnectionStatus
    isDegraded: boolean
    forceReconnect: () => void
}

/**
 * Hook to subscribe to websocket connection health status.
 * Works for both leader and follower tabs - leader broadcasts status, all tabs receive it.
 */
export const useWebsocketHealth = (): WebsocketHealthResult => {
    const [status, setStatus] = useState<ConnectionStatus>('connected')

    useEffect(() => {
        const hub = getWsHub()
        if (!hub) return

        const unsubscribe = hub.subscribe<ConnectionStatusPayload>(
            TOPIC_LEADER_CONNECTION_STATUS,
            (payload) => {
                setStatus(payload.status)
            },
        )

        return unsubscribe
    }, [])

    const forceReconnect = useCallback((): void => {
        const hub = getWsHub()
        hub?.publish(TOPIC_FORCE_RECONNECT, {})
    }, [])

    return {
        status,
        isDegraded: status === 'degraded',
        forceReconnect,
    }
}
